import { useMemo } from 'react';
import {
  PAYMENT_MODE_OPTIONS,
  TRANSACTION_TYPE_OPTIONS,
  PAYMENT_TYPE_OPTIONS,
} from '../constants';

export const usePaymentsFormFields = () => {
  return useMemo(
    () => [
      {
        name: 'type',
        label: 'Payment Type',
        type: 'customAutoComplete',
        required: true,
        options: [...PAYMENT_TYPE_OPTIONS],
        placeholder: 'Select or type payment type',
        layout: { span: 12 },
        props: {
          size: 'medium',
          maxLength: 100,
          showCount: false,
          style: { width: '100%' },
          allowClear: true,
        },
        onChange: (value: string, form: any) => {
          // Auto-set transaction type based on payment type
            if (value === 'MEDICAL_SALES' || value === 'PATIENT_INVOICE') {
            form.setFieldsValue({ transaction_type: 'CREDIT' });
          } else if (value === 'MEDICAL_PURCHASES' || value === 'CLINIC_EXPENSES') {
            form.setFieldsValue({ transaction_type: 'DEBIT' });
          }
        },
      },
      {
        name: 'reference_id',
        label: 'Reference ID',
        type: 'number',
        required: false,
        placeholder: 'Enter reference ID',
        layout: { span: 12 },
        min: 1,
      },
      {
        name: 'transaction_type',
        label: 'Transaction Type',
        type: 'select',
        required: true,
        options: TRANSACTION_TYPE_OPTIONS,
        placeholder: 'Select transaction type',
        layout: { span: 12 },
        disabled: true, // Make it read-only since it's auto-set
      },
      {
        name: 'amount',
        label: 'Amount',
        type: 'number',
        required: true,
        placeholder: 'Enter amount',
        layout: { span: 12 },
        min: 0,
        step: 0.01,
        format: 'currency',
      },
      {
        name: 'payment_mode',
        label: 'Payment Mode',
        type: 'select',
        required: true,
        options: PAYMENT_MODE_OPTIONS,
        placeholder: 'Select payment mode',
        layout: { span: 12 },
      },
      {
        name: 'remark',
        label: 'Remark',
        type: 'textarea',
        required: false,
        placeholder: 'Enter remark (optional)',
        layout: { span: 24 },
        props: {
          rows: 3,
          showCount: true,
          maxLength: 255,
        },
      },
    ],
    []
  );
};
